var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 71,
    viewBox: "0 0 136 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_602_1111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2521 70.1214V66.7509H16.5671L17.8013 66.004H15.0319L14.2521 66.4785V62.8845H19.0233V62.1345H13.0332V70.8714H19.186V70.1214H14.2521Z",
    fill: "url(#paint0_linear_602_1111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6915 70.1214V66.7509H65.0096L66.2438 66.004H63.4714L62.6915 66.4785V62.8845H67.4658V62.1345H61.4727V70.8714H67.6254V70.1214H62.6915Z",
    fill: "url(#paint1_linear_602_1111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.853 69.6254L30.3586 68.2632C30.0455 67.3387 29.6003 66.8397 28.5073 66.705V66.6652C29.674 66.6407 30.9911 66.0682 30.9911 64.4947C30.9911 62.7621 29.5266 62.1376 27.7366 62.1376H24.3809V70.8714H25.5967V67.0172H27.2884C28.4305 67.0172 28.7805 67.3662 29.1152 68.3152L29.6371 69.7234C29.7231 69.9744 29.9472 70.5224 30.1959 70.8714H31.5622C31.2275 70.4734 31.0034 70.0479 30.853 69.6254ZM25.5967 66.2917V62.86H27.488C28.7805 62.86 29.6617 63.3345 29.6617 64.5192C29.6617 65.8693 28.6823 66.2917 27.488 66.2917H25.5967Z",
    fill: "url(#paint2_linear_602_1111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1741 62.009C37.6902 62.009 35.8389 63.9836 35.8389 66.4999C35.8389 69.0163 37.6872 70.9908 40.1741 70.9908C42.661 70.9908 44.5001 69.0193 44.5001 66.4999C44.5001 63.9805 42.6579 62.009 40.1741 62.009ZM40.1741 70.2928C38.3473 70.2928 37.2174 68.8204 37.2174 66.4999C37.2174 64.1795 38.3503 62.707 40.1741 62.707C41.9978 62.707 43.1307 64.1825 43.1307 66.4999C43.1307 68.8173 42.0009 70.2928 40.1741 70.2928Z",
    fill: "url(#paint3_linear_602_1111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6455 62.1345H56.5389L52.7748 70.9449H52.1914L48.4365 62.1345H49.7322L52.7011 69.2458L55.6455 62.1345Z",
    fill: "url(#paint4_linear_602_1111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.893444 70.8714H0L3.76413 62.061H4.34748L8.1024 70.8714H6.80982L3.83782 63.76L0.893444 70.8714Z",
    fill: "url(#paint5_linear_602_1111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.615 70.8714H116.725L120.486 62.061H121.072L124.827 70.8714H123.531L120.562 63.76L117.615 70.8714Z",
    fill: "url(#paint6_linear_602_1111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2955 69.6254L78.7981 68.2632C78.488 67.3387 78.0428 66.8397 76.9467 66.705V66.6652C78.1134 66.6407 79.4306 66.0682 79.4306 64.4947C79.4306 62.7621 77.9661 62.1376 76.1761 62.1376H72.8203V70.8714H74.0392V67.0172H75.7278C76.873 67.0172 77.22 67.3662 77.5546 68.3152L78.0797 69.7234C78.1656 69.9744 78.3867 70.5224 78.6354 70.8714H80.0016C79.667 70.4734 79.4459 70.0479 79.2955 69.6254ZM74.0392 66.2917V62.86H75.9274C77.22 62.86 78.1042 63.3345 78.1042 64.5192C78.1042 65.8693 77.1217 66.2917 75.9274 66.2917H74.0392Z",
    fill: "url(#paint7_linear_602_1111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.753 62.1376H107.397V70.8714H108.616V67.0172H108.739C109.881 67.0172 110.554 67.0601 111.251 66.9805C112.411 66.8458 114.008 66.0682 114.008 64.4947C114.008 62.7621 112.543 62.1376 110.753 62.1376ZM110.505 66.2917H108.616V62.86H110.505C111.797 62.86 112.678 63.3345 112.678 64.5192C112.678 65.8693 111.699 66.2917 110.505 66.2917Z",
    fill: "url(#paint8_linear_602_1111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0304 67.103L86.8361 66.7785C85.3562 66.3805 84.5119 65.805 84.5119 64.4458C84.5119 63.0866 85.8045 62.0121 87.5422 62.0121C88.9975 62.0121 90.1243 62.6856 90.6739 63.6101L90.066 64.1978C89.5686 63.3009 88.6629 62.7621 87.5453 62.7621C86.4277 62.7621 85.6694 63.2978 85.6694 64.1856C85.6694 65.0734 86.2036 65.3703 87.2843 65.6611L88.451 65.9734C89.9063 66.3621 90.7998 67.0081 90.7998 68.3061C90.7998 70.002 89.3076 71 87.5791 71C86.0501 71 84.647 70.2653 84.0605 69.102L84.6838 68.5754C85.3685 69.7357 86.4738 70.2102 87.5791 70.2102C88.758 70.2102 89.6423 69.6836 89.6423 68.6367C89.6423 67.7397 89.0098 67.3662 88.0273 67.0999H88.0304V67.103Z",
    fill: "url(#paint9_linear_602_1111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1982 70.1214V66.7509H99.5163L100.751 66.004H97.9781L97.1982 66.4785V62.8845H101.972V62.1345H95.9824V70.8714H102.132V70.1214H97.1982Z",
    fill: "url(#paint10_linear_602_1111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.842 70.9999V67.2101L127.32 62.061H128.963L130.523 64.5284C130.946 65.205 131.287 65.7468 131.628 66.3713H131.662C131.969 65.7835 132.346 65.1988 132.776 64.5192L134.379 62.058H136.006L132.288 67.1887V70.9938H130.845L130.842 70.9999Z",
    fill: "url(#paint11_linear_602_1111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2474 22.4849C56.2474 25.2248 54.2548 26.0819 51.8324 26.0819H48.0068V19.1206H51.8324C54.4544 19.1206 56.2474 20.0788 56.2474 22.488V22.4849Z",
    fill: "url(#paint12_linear_602_1111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4169 20.9911L63.5791 30.2545L65.1725 31.4545C66.548 32.3392 67.2757 29.7463 67.3094 29.6086V29.6024H67.3125C67.3125 29.6024 67.3125 29.6177 67.3156 29.6269C67.3801 29.8841 68.0371 32.2474 69.4463 31.4545L71.2271 30.1167L67.4169 20.9911ZM67.4169 20.9911L63.5791 30.2545L65.1725 31.4545C66.548 32.3392 67.2757 29.7463 67.3094 29.6086V29.6024H67.3125C67.3125 29.6024 67.3125 29.6177 67.3156 29.6269C67.3801 29.8841 68.0371 32.2474 69.4463 31.4545L71.2271 30.1167L67.4169 20.9911ZM67.4169 20.9911L63.5791 30.2545L65.1725 31.4545C66.548 32.3392 67.2757 29.7463 67.3094 29.6086V29.6024H67.3125C67.3125 29.6024 67.3125 29.6177 67.3156 29.6269C67.3801 29.8841 68.0371 32.2474 69.4463 31.4545L71.2271 30.1167L67.4169 20.9911ZM67.4169 20.9911L63.5791 30.2545L65.1725 31.4545C66.548 32.3392 67.2757 29.7463 67.3094 29.6086V29.6024H67.3125C67.3125 29.6024 67.3125 29.6177 67.3156 29.6269C67.3801 29.8841 68.0371 32.2474 69.4463 31.4545L71.2271 30.1167L67.4169 20.9911ZM67.4169 20.9911L63.5791 30.2545L65.1725 31.4545C66.548 32.3392 67.2757 29.7463 67.3094 29.6086V29.6024H67.3125C67.3125 29.6024 67.3125 29.6177 67.3156 29.6269C67.3801 29.8841 68.0371 32.2474 69.4463 31.4545L71.2271 30.1167L67.4169 20.9911ZM67.4169 20.9911L63.5791 30.2545L65.1725 31.4545C66.548 32.3392 67.2757 29.7463 67.3094 29.6086V29.6024H67.3125C67.3125 29.6024 67.3125 29.6177 67.3156 29.6269C67.3801 29.8841 68.0371 32.2474 69.4463 31.4545L71.2271 30.1167L67.4169 20.9911ZM67.4169 20.9911L63.5791 30.2545L65.1725 31.4545C66.548 32.3392 67.2757 29.7463 67.3094 29.6086V29.6024H67.3125C67.3125 29.6024 67.3125 29.6177 67.3156 29.6269C67.3801 29.8841 68.0371 32.2474 69.4463 31.4545L71.2271 30.1167L67.4169 20.9911ZM92.2706 10.9379L69.9161 0.453035C69.3634 0.195888 68.7678 0.0244573 68.1568 0.00302837C68.0555 -3.28952e-05 67.9511 -3.28952e-05 67.8498 0.00302837C67.2388 0.0244573 66.6432 0.192827 66.0905 0.453035L43.7391 10.9409C41.6329 11.541 40.1807 13.4634 40.1807 15.6492V37.476C40.1807 39.6618 41.6329 41.5812 43.7391 42.1842L66.0905 52.6722C66.6432 52.9324 67.2388 53.1007 67.8498 53.1222C67.9511 53.1252 68.0555 53.1252 68.1568 53.1222C68.7678 53.1038 69.3634 52.9324 69.9161 52.6722L92.2675 42.1842C94.3737 41.5842 95.826 39.6618 95.826 37.476V15.6492C95.826 13.4634 94.3737 11.544 92.2675 10.9409L92.2706 10.9379ZM53.349 27.4718C51.9336 27.6371 50.5673 27.5422 48.2493 27.5422H48.0037V35.3637H45.5321V17.6512H52.3389C55.971 17.6512 58.9399 18.9186 58.9399 22.4329C58.9399 25.6258 55.7008 27.1993 53.349 27.4687V27.4718ZM76.5048 26.3912L73.4285 29.1463L76.1855 35.6209H73.5236L71.531 30.8453L67.3125 34.6229H67.3094L63.269 31.0014L61.3562 35.6209H59.5202L61.9856 29.8504L58.0864 26.3605H58.4026L62.2404 29.2473L67.2603 17.4982H68.4639L73.2043 28.6259L76.2193 26.3605H76.5386L76.5048 26.3912ZM84.7331 27.9034V35.6209H82.1664V27.9402L76.8242 17.5012H79.4369L83.4651 26.2473C84.0853 25.0564 87.5301 17.5012 87.5301 17.5012H90.4684L84.7331 27.9065V27.9034ZM63.576 30.2545L65.1695 31.4545C66.5449 32.3392 67.2726 29.7463 67.3064 29.6086V29.6024H67.3094C67.3094 29.6024 67.3094 29.6177 67.3125 29.6269C67.377 29.8841 68.034 32.2474 69.4433 31.4545L71.224 30.1167L67.4138 20.9911L63.576 30.2545ZM67.4138 20.9911L63.576 30.2545L65.1695 31.4545C66.5449 32.3392 67.2726 29.7463 67.3064 29.6086V29.6024H67.3094C67.3094 29.6024 67.3094 29.6177 67.3125 29.6269C67.377 29.8841 68.034 32.2474 69.4433 31.4545L71.224 30.1167L67.4138 20.9911ZM67.4138 20.9911L63.576 30.2545L65.1695 31.4545C66.5449 32.3392 67.2726 29.7463 67.3064 29.6086V29.6024H67.3094C67.3094 29.6024 67.3094 29.6177 67.3125 29.6269C67.377 29.8841 68.034 32.2474 69.4433 31.4545L71.224 30.1167L67.4138 20.9911ZM67.4138 20.9911L63.576 30.2545L65.1695 31.4545C66.5449 32.3392 67.2726 29.7463 67.3064 29.6086V29.6024H67.3094C67.3094 29.6024 67.3094 29.6177 67.3125 29.6269C67.377 29.8841 68.034 32.2474 69.4433 31.4545L71.224 30.1167L67.4138 20.9911ZM67.4138 20.9911L63.576 30.2545L65.1695 31.4545C66.5449 32.3392 67.2726 29.7463 67.3064 29.6086V29.6024H67.3094C67.3094 29.6024 67.3094 29.6177 67.3125 29.6269C67.377 29.8841 68.034 32.2474 69.4433 31.4545L71.224 30.1167L67.4138 20.9911ZM67.4138 20.9911L63.576 30.2545L65.1695 31.4545C66.5449 32.3392 67.2726 29.7463 67.3064 29.6086V29.6024H67.3094C67.3094 29.6024 67.3094 29.6177 67.3125 29.6269C67.377 29.8841 68.034 32.2474 69.4433 31.4545L71.224 30.1167L67.4138 20.9911ZM67.4138 20.9911L63.576 30.2545L65.1695 31.4545C66.5449 32.3392 67.2726 29.7463 67.3064 29.6086V29.6024H67.3094C67.3094 29.6024 67.3094 29.6177 67.3125 29.6269C67.377 29.8841 68.034 32.2474 69.4433 31.4545L71.224 30.1167L67.4138 20.9911ZM67.4138 20.9911L63.576 30.2545L65.1695 31.4545C66.5449 32.3392 67.2726 29.7463 67.3064 29.6086V29.6024H67.3094C67.3094 29.6024 67.3094 29.6177 67.3125 29.6269C67.377 29.8841 68.034 32.2474 69.4433 31.4545L71.224 30.1167L67.4138 20.9911Z",
    fill: "url(#paint13_linear_602_1111)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_602_1111",
    x1: 16.1093,
    y1: 70.871,
    x2: 16.1093,
    y2: 62.1344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EC6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#88D6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_602_1111",
    x1: 64.5487,
    y1: 70.871,
    x2: 64.5487,
    y2: 62.1344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EC6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#88D6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_602_1111",
    x1: 27.9711,
    y1: 70.871,
    x2: 27.9711,
    y2: 62.1374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EC6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#88D6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_602_1111",
    x1: 40.169,
    y1: 70.9904,
    x2: 40.169,
    y2: 62.0089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EC6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#88D6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_602_1111",
    x1: 52.4873,
    y1: 70.9445,
    x2: 52.4873,
    y2: 62.1344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EC6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#88D6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_602_1111",
    x1: 4.05075,
    y1: 70.871,
    x2: 4.05075,
    y2: 62.0609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EC6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#88D6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_602_1111",
    x1: 120.775,
    y1: 70.871,
    x2: 120.775,
    y2: 62.0609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EC6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#88D6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_602_1111",
    x1: 76.4106,
    y1: 70.871,
    x2: 76.4106,
    y2: 62.1374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EC6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#88D6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_602_1111",
    x1: 110.702,
    y1: 70.871,
    x2: 110.702,
    y2: 62.1374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EC6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#88D6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_602_1111",
    x1: 87.4298,
    y1: 70.9996,
    x2: 87.4298,
    y2: 62.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EC6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#88D6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_602_1111",
    x1: 99.0569,
    y1: 70.871,
    x2: 99.0569,
    y2: 62.1344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EC6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#88D6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_602_1111",
    x1: 131.663,
    y1: 70.9996,
    x2: 131.663,
    y2: 62.0579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EC6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#88D6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_602_1111",
    x1: 52.124,
    y1: 26.0789,
    x2: 52.124,
    y2: 19.1175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EC6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#88D6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_602_1111",
    x1: 68.0002,
    y1: 53.1222,
    x2: 68.0002,
    y2: -0.0000338299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EC6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#88D6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD8EE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_602_1111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 71,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.abd53005eaef5c4bc2549e622629aa5d.svg";
export { ForwardRef as ReactComponent };